// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1646":"01fa33e1","6028":"c563be50","7282":"01fa33e1","7290":"7870ee31","7806":"01fa33e1"}[chunkId] + ".chunk.css";
};